import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function DocPageTabModal({
  allTabCurrent,
  unsortedTabCurrent,
  associatedTabCurrent,
  lastTabCurrent,
  savePrefrenceCallback,
  setHomeData,
}) {
  const { register, setValue, watch } = useFormContext();

  const [selected, setSelected] = useState(null);

  // Effect to set the selected state based on populated fields
  useEffect(() => {
    if (allTabCurrent) {
      setSelected(1);
      setValue("DocPageAll", true);
      setValue("DocPageUnsorted", false);
      setValue("DocPagePrior", false);
      setValue("DocTabForPage", false);
    } else if (unsortedTabCurrent) {
      setSelected(2);
      setValue("DocPageAll", false);
      setValue("DocPageUnsorted", true);
      setValue("DocPagePrior", false);
      setValue("DocTabForPage", false);
    } else if (associatedTabCurrent) {
      setSelected(3);
      setValue("DocPageAll", false);
      setValue("DocPageUnsorted", false);
      setValue("DocPagePrior", true);
      setValue("DocTabForPage", false);
    } else if (lastTabCurrent) {
      setSelected(4);
      setValue("DocPageAll", false);
      setValue("DocPageUnsorted", false);
      setValue("DocPagePrior", false);
      setValue("DocTabForPage", true);
    }
  }, [allTabCurrent, unsortedTabCurrent, associatedTabCurrent, lastTabCurrent, setValue]);

  const handleSelected = (selectedValue) => {
    // Update the selected state
    setSelected(selectedValue);

    // Set the corresponding DocPage value to true and others to false
    setValue("DocPageAll", selectedValue === 1);
    setValue("DocPageUnsorted", selectedValue === 2);
    setValue("DocPagePrior", selectedValue === 3);
    setValue("DocTabForPage", selectedValue === 4);

    setTimeout(() => {
      const updatedValues = watch();
      savePrefrenceCallback(updatedValues);
      setHomeData(updatedValues);
    }, 0);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-evenly"
      style={{ height: "max-content", gap: "0px" }}
    >
      <div className="d-flex radio-buttons" style={{ gap: "0px" }}>
        <div
          className={"d-flex align-items-center gap-1 height-35 "}
          onClick={() => handleSelected(1)} // Set selected to 1
        >
          <input
            type="radio"
            value="DocPageAll"
            {...register("DocPageAll")}
            className="radio-input"
            checked={selected === 1} // Reflect the selected state
            readOnly // Make the input read-only
          />
          <div className={`radio-circle ${selected === 1 ? "checked" : ""}`} />
          <span>All Tab</span>
        </div>

        <div
          className={"height-35 d-flex align-items-center gap-1 "}
          onClick={() => handleSelected(2)} // Set selected to 2
        >
          <input
            type="radio"
            value="DocPageUnsorted"
            {...register("DocPageUnsorted")}
            className="radio-input"
            checked={selected === 2}
            readOnly
          />
          <div className={`radio-circle ${selected === 2 ? "checked" : ""}`} />
          <span>Unsorted Tab</span>
        </div>
      </div>

      <div className="d-flex radio-buttons" style={{ gap: "0px" }}>
        <div
          className={"d-flex align-items-center gap-1 height-35"}
          onClick={() => handleSelected(3)} // Set selected to 3
        >
          <input
            type="radio"
            value="DocPagePrior"
            {...register("DocPagePrior")}
            className="radio-input"
            checked={selected === 3}
            readOnly
          />
          <div className={`radio-circle ${selected === 3 ? "checked" : ""}`} />
          <span>Prior Page Associated Tab</span>
        </div>

        <div
          className={"height-35  d-flex align-items-center gap-1 "}
          onClick={() => handleSelected(4)} // Set selected to 4
        >
          <input
            type="radio"
            value="DocTabForPage"
            {...register("DocTabForPage")}
            className="radio-input"
            checked={selected === 4}
            readOnly
          />
          <div className={`radio-circle ${selected === 4 ? "checked" : ""}`} />
          <span>Last Tab Accessed</span>
        </div>
      </div>
    </div>
  );
}

export default DocPageTabModal;
